
export const SUCCESS                   = 200;
export const BAD_SERVER_RESPONSE_RANGE = 400;
export const NOT_FOUND                 = 404;
export const VALIDATION_ERROR          = 422;
export const SERVER_ERROR              = 500;
export const UNAUTHORIZED              = 401;
